<template>
  <ul class="episode-stats">
    <li v-for="stat in stats" :key="stat.name" class="episode-stats__item">
      <sprite :id="stat.name" /><span class="episode-stats__text">{{ stat.text }}</span>
    </li>
  </ul>
</template>

<script>
import Sprite from "@/shared/sprite"
import "/wds/sprites/app/time.svg"
import "/wds/sprites/app/audio.svg"

export default {
  name: "EpisodeStats",
  components: {
    Sprite
  },
  props: {
    duration: {
      type: Number,
      required: true
    }
  },
  computed: {
    stats() {
      return [
        {
          name: "app/time",
          text: `${Math.round(this.duration / 60)} ${this.$t("mins")}`
        },
        {
          name: "app/audio",
          text: this.$t("audio")
        }
      ]
    }
  },
  i18n: {
    messages: {
      de: {
        mins: "Min.",
        keyIdeas: "Kernaussagen",
        audio: "Audio"
      },
      en: {
        mins: "mins",
        keyIdeas: "Key ideas",
        audio: "Audio"
      }
    }
  }
}
</script>

<style lang="scss">
.episode-stats {
  @include font-style(h5);

  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  padding: $spacing-16 0;

  border-top: 1px solid $lightest-grey;
  border-bottom: 1px solid $lightest-grey;

  &__item {
    display: flex;
    align-content: center;

    &:not(:first-of-type) {
      margin-left: $spacing-32;
    }
  }

  &__text {
    margin-left: $spacing-8;
  }
}
</style>
